import { useFormik } from "formik";
import React, { useRef } from "react";
// internal
import ErrorMsg from "./error-msg";
import { portfolio_schema } from "utils/validation-schema";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ENQUIRY_EMAIL = "rionickstudios@gmail.com";
const BRAND_EMAIL = "contact@rionick.com";
const FORMSUBMIT_ENDPOINT = `https://formsubmit.co/ajax/${ENQUIRY_EMAIL}`;
const AUTO_REPLY_MESSAGE =
  "Thank you for contacting Rionick Studios. We have received your enquiry and our team will get back to you soon. For anything urgent, you can reply to us at contact@rionick.com.";

const PortfolioContactForm = () => {
  const formref = useRef()
  // use formik
  const { handleChange, handleSubmit, handleBlur, errors, values, touched, isSubmitting } =
    useFormik({
      initialValues: {
        to_name: "",
        to_email: "",
        phone: "",
        subject: "",
        message: "",
      },

      validationSchema: portfolio_schema,
      onSubmit: async (values, { resetForm, setSubmitting }) => {
        const formData = new FormData();
        formData.append("Name", values.to_name);
        formData.append("email", values.to_email);
        formData.append("Email", values.to_email);
        formData.append("Phone", values.phone);
        formData.append("Subject", values.subject);
        formData.append("Message", values.message);
        formData.append("_subject", `New Rionick website enquiry: ${values.subject}`);
        formData.append("_template", "table");
        formData.append("_captcha", "false");
        formData.append("_replyto", BRAND_EMAIL);
        formData.append("_autoresponse", AUTO_REPLY_MESSAGE);

        try {
          const response = await fetch(FORMSUBMIT_ENDPOINT, {
            method: "POST",
            headers: {
              Accept: "application/json",
            },
            body: formData,
          });

          if (!response.ok) {
            throw new Error(`FormSubmit returned ${response.status}`);
          }

          toast.success("Message sent successfully. We'll contact you soon.", {
            style: {
              top: 100,
            }
          });
          resetForm();
        } catch (error) {
          console.error("Contact form AJAX submission failed, using form post fallback:", error);
          toast.info("Opening secure submit page to finish sending your message...", {
            style: {
              top: 100,
            }
          });

          window.setTimeout(() => {
            if (formref.current) {
              formref.current.submit();
            }
          }, 700);
        } finally {
          setSubmitting(false);
        }
      },
    });
  return (
    <>
      <ToastContainer />
      <form
        id="contact-form"
        onSubmit={handleSubmit}
        ref={formref}
        action={`https://formsubmit.co/${ENQUIRY_EMAIL}`}
        method="POST"
      >
        <input type="hidden" name="_subject" value="New Rionick website enquiry" readOnly />
        <input type="hidden" name="_template" value="table" readOnly />
        <input type="hidden" name="_captcha" value="false" readOnly />
        <input type="hidden" name="_replyto" value={BRAND_EMAIL} readOnly />
        <input type="hidden" name="_autoresponse" value={AUTO_REPLY_MESSAGE} readOnly />
        <input type="hidden" name="_next" value="https://www.rionick.com/contact-us" readOnly />
        <div className="row">
          <div className="col-lg-6">
            <div className="contact__input-9">
              <input
                name="to_name"
                value={values.to_name}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                placeholder="Your name*"
                id="to_name"
              />
              <input
                name="from_name"
                value={"Rionick Studio"}
                type="hidden"
                placeholder="Your name*"
                id="name"
                readOnly
              />
              <input
                name="reply_to"
                value={values.to_email}
                type="hidden"
                readOnly
              />
              <input
                name="contact_to"
                value={ENQUIRY_EMAIL}
                type="hidden"
                readOnly
              />
              {touched.to_name && <ErrorMsg error={errors.to_name} />}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="contact__input-9">
              <input
                name="to_email"
                value={values.to_email}
                onChange={handleChange}
                onBlur={handleBlur}
                type="email"
                placeholder="Your email address*"
                id="email"
              />
              <input
                name="email"
                value={values.to_email}
                type="hidden"
                readOnly
              />
              {touched.to_email && <ErrorMsg error={errors.to_email} />}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="contact__input-9">
              <input
                name="phone"
                value={values.phone}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                placeholder="Mobile Number"
                id="phone"
              />
              {touched.phone && <ErrorMsg error={errors.phone} />}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="contact__input-9">
              <input
                name="subject"
                value={values.subject}
                onChange={handleChange}
                onBlur={handleBlur}
                type="text"
                placeholder="Subject"
                id="subject"
              />
              {touched.subject && <ErrorMsg error={errors.subject} />}
            </div>
          </div>
          <div className="col-lg-12">
            <div className="contact__input-9">
              <textarea
                name="message"
                value={values.message}
                onChange={handleChange}
                onBlur={handleBlur}
                id="msg"
                placeholder="How can we help you?"
              ></textarea>
              {touched.message && <ErrorMsg error={errors.message} />}
            </div>
          </div>
          <div className="col-lg-12">
            <div className="contact__btn-9">
              <button type="submit" className="tp-btn-6 w-100" disabled={isSubmitting}>
                {isSubmitting ? "SENDING..." : "SEND MESSAGE"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default PortfolioContactForm;
